import type { Prisma } from "@prisma/client"
import dayjs from "dayjs"

export const planStatusFields = {
  archivedAt: true,
  isPlanPaused: true,
  hasStartedPaidPlan: true,
  teamEvent: { select: { event: { select: { expiresAt: true } } } },
  trialInvite: { select: { trialEndDate: true } },
  activeOrder: { select: { planEndDate: true } },
} satisfies Prisma.TeamSelect

export type CompanyPlanStatusFields = Prisma.TeamGetPayload<{ select: typeof planStatusFields }>

export function getPlanStatus(company: CompanyPlanStatusFields | null) {
  if (!company) return "no company"
  if (company.archivedAt) return "archived"
  if (company.trialInvite && !company.hasStartedPaidPlan) {
    if (dayjs(company.trialInvite.trialEndDate).isBefore(dayjs())) return "trial expired"
    return "trialing"
  }
  if (company.teamEvent) {
    if (dayjs(company.teamEvent.event.expiresAt).isBefore(dayjs())) return "event expired"
    return "event active"
  }
  if (company.isPlanPaused) return "paused"
  if (!company.activeOrder) return "no plan"
  const planEndDate = company.activeOrder.planEndDate
  if (!planEndDate) return "pending payment" // TODO: check if this is correct
  if (dayjs(planEndDate).isAfter(dayjs()) && dayjs(planEndDate).isBefore(dayjs().add(2, "months"))) return "expiring soon"
  if (dayjs(planEndDate).isBefore(dayjs())) return "expired"
  if (dayjs(planEndDate).isAfter(dayjs())) return "active"
  return "unknown"
}

export type CompanyPlanStatus = ReturnType<typeof getPlanStatus>
